import Vue from 'vue'

export const EUR = value => value ? `${value} EUR` : '-'

export const KC = value => value ? `${value} Kč` : '-'

Vue.filter('KC', KC)
Vue.filter('EUR', EUR)
